import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardPage } from "@/components/admin/pages/AdminDashboardPage";

export const Route = createFileRoute("/pulse-ops-x7k2/dashboard")({
  component: AdminDashboardPage,
});
